import { FieldConfig } from '../ModalFieldRenderer';
import { Grade } from '../../../services/api/domains/grades/types';
import { validationHelpers } from '../utils/validation';
import { formatDateTime } from 'utils/dateConversion';

export const gradeIdField: FieldConfig<Grade> = {
  key: 'grade_id',
  label: 'Product Type ID',
  type: 'readonly',
  getValue: (grade: Grade) => grade.grade_id?.toString() || '',
  isAlwaysDisabled: true,
};

export const gradeFields: FieldConfig<Grade>[] = [
  {
    key: 'grade_name',
    label: 'Product Type',
    type: 'text',
    getValue: (grade: Grade) => grade.grade_name || '',
    setValue: (grade: Grade, value: string) => ({
      ...grade,
      grade_name: value,
    }),
    isRequired: true,
    validator: validationHelpers.combine(
      validationHelpers.required,
      validationHelpers.minLength(2)
    ),
  },
  {
    key: 'created_date',
    label: 'Created',
    type: 'readonly',
    getValue: (grade: Grade) => grade.created_date || '',
    formatter: formatDateTime,
    isAlwaysDisabled: true,
  },
  {
    key: 'modified_date',
    label: 'Last Updated',
    type: 'readonly',
    getValue: (grade: Grade) => grade.modified_date || '',
    formatter: formatDateTime,
    isAlwaysDisabled: true,
  },
  {
    key: 'user_id',
    label: 'User ID',
    type: 'readonly',
    getValue: (grade: Grade) => grade.user_id || '',
    isAlwaysDisabled: true,
  },
];

export const gradeAlwaysDisabledFields: (keyof Grade)[] = [
  'grade_id',
  'created_date',
  'modified_date',
  'user_id',
];
